import React from "react";
import { SupportLink } from "@/features/shell/components/shared/SupportLink";
import { Link } from "@/features/shell/components/shared/Link/Link";
import type { Link as LinkType } from "@/features/account/components/about/Links";

import * as styles from "./Footer.module.scss";

type FooterLinkProps = {
  link: LinkType;
};

const FooterLink = ({ link }: FooterLinkProps) => {
  if (link.supportOptions) {
    return (
      <SupportLink
        options={link.supportOptions}
        className={styles.link}
        hideChevron
      >
        <span data-nosnippet={link.noSnippet || undefined}>{link.name}</span>
      </SupportLink>
    );
  }

  if (link.href) {
    return (
      <a
        className={styles.link}
        href={link.href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {link.name}
      </a>
    );
  }

  if (link.to) {
    return (
      <Link className={styles.link} to={link.to} nolang={link.nolang}>
        {link.name}
      </Link>
    );
  }

  if (typeof link.action === "function") {
    return (
      <button className={styles.link} onClick={link.action}>
        {link.name}
      </button>
    );
  }

  return null;
};

export { FooterLink };
